<div class="flex flex-col">
  <div *ngIf="proof" class="bg-white rounded-lg shadow-sm border border-gray-200 p-5 animate-slide-in-left mb-4">
    <div class="flex justify-between items-start">
      <div>
        <p class="text-2xl font-semibold text-dark">{{ proof.generated_name }}</p>
        <p class="text-sm text-gray-500 mt-1">{{ proof.date | date:'dd \'de\' MMMM \'de\' yyyy':'':'es' }}</p>
      </div>
      <div class="flex items-center gap-3">
        <div *ngIf="proof.current_state" class="flex items-center gap-1.5 px-3 py-1 text-xs font-semibold rounded-full text-white" [style.background-color]="proof.current_state.color">
          {{ proof.current_state.name }}
        </div>
        <button (click)="toggleActiveProofForm()"
          class="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary hover:text-white transition-colors duration-200">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          Editar
        </button>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-4 mt-4 pt-4 border-t border-gray-100">
      <div>
        <span class="text-xs font-medium text-gray-500">Fecha y hora</span>
        <p class="text-sm text-dark mt-0.5" [ngClass]="proof.date_time ? '' : 'text-gray-400 italic'">
          {{ proof.date_time ? (proof.date_time | date:'dd/MM/yyyy HH:mm') : '—' }}
        </p>
      </div>
      <div>
        <span class="text-xs font-medium text-gray-500">Tope de inscripción</span>
        <p class="text-sm mt-0.5" [ngClass]="proof.registration_deadline ? 'text-dark' : 'text-gray-400 italic'">
          {{ proof.registration_deadline ? (proof.registration_deadline | date:'dd/MM/yyyy') : '—' }}
        </p>
      </div>
    </div>
  </div>

  <!-- Propuestas de examen (profesor propone; admin acepta/rechaza) -->
  <app-exam-proposals-panel *ngIf="proof" [proof]="proof"></app-exam-proposals-panel>

  <!-- Pestañas -->
  <div class="flex items-center justify-between border-b border-gray-200 mb-6">
    <div class="flex gap-x-2">
    <button
      (click)="setActiveTab('students')"
      [class]="activeTab === 'students' 
        ? 'px-6 py-3 text-sm font-semibold text-primary border-b-2 border-primary' 
        : 'px-6 py-3 text-sm font-medium text-gray-600 hover:text-primary hover:border-b-2 hover:border-gray-300 transition-all duration-200'"
    >
      <div class="flex items-center gap-x-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        <span>Alumnos</span>
      </div>
    </button>
    
    <button 
      (click)="setActiveTab('dgt-procedures')"
      [class]="activeTab === 'dgt-procedures' 
        ? 'px-6 py-3 text-sm font-semibold text-primary border-b-2 border-primary' 
        : 'px-6 py-3 text-sm font-medium text-gray-600 hover:text-primary hover:border-b-2 hover:border-gray-300 transition-all duration-200'"
    >
      <div class="flex items-center gap-x-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        <span>Trámites DGT</span>
      </div>
    </button>
    </div>
    <button
      (click)="presentProof()"
      [disabled]="isPresenting"
      class="px-4 py-2 mb-1 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-x-2">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/>
      </svg>
      <span>{{ isPresenting ? 'Presentando...' : 'Presentar convocatoria' }}</span>
    </button>
  </div>

  <!-- Contenido según pestaña activa -->
  <div *ngIf="activeTab === 'students'">
    <app-generic-crud #alumnosCrud [genericCrud]="genericCRUD"></app-generic-crud>
  </div>

  <!-- Modal errores de presentación -->
  <div *ngIf="showPresentationErrorsModal" class="fixed inset-0 z-[200] flex items-center justify-center modal-backdrop p-4">
    <div class="bg-white rounded-3xl shadow-2xl w-full max-w-2xl animate-slide-in-top">
      <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
        <h2 class="text-2xl font-bold text-gray-800">Errores de validación para presentación</h2>
        <button (click)="showPresentationErrorsModal = false"
          class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
      <div class="px-8 py-6 space-y-3">
        <p class="text-sm text-gray-600 mb-4">Los siguientes alumnos no cumplen los requisitos para ser presentados:</p>
        <div *ngFor="let err of presentationErrors" class="border border-red-200 rounded-lg p-3 bg-red-50">
          <h4 class="font-semibold text-dark text-sm">{{ err.user_name }}</h4>
          <ul class="mt-1 space-y-1">
            <li *ngFor="let issue of err.issues" class="text-sm text-red-600 flex items-center gap-x-2">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
              {{ issue }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="activeTab === 'dgt-procedures'" class="animate-fade-in">
    <div class="bg-white rounded-lg shadow-md border border-gray-200 p-6">
      <!-- Header con acciones bulk -->
      <div class="flex justify-between items-center mb-6 min-h-16">
        <div class="flex items-center gap-x-4">
          <h3 class="text-lg font-semibold text-dark">Gestión de Trámites DGT</h3>
          <span class="text-sm text-gray-500" *ngIf="selectedCards.size > 0">
            ({{ selectedCards.size }} seleccionada{{ selectedCards.size > 1 ? 's' : '' }})
          </span>
        </div>
        
        <!-- Acciones bulk -->
        <div class="flex items-center gap-x-3" *ngIf="cards.length > 0">
          <label class="flex items-center gap-x-2 text-sm text-gray-600 cursor-pointer hover:text-primary">
            <input 
              type="checkbox" 
              [checked]="allSelected"
              (change)="toggleSelectAll()"
              class="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
            />
            <span>Seleccionar todo</span>
          </label>
          
          <div class="flex items-center gap-x-2" *ngIf="selectedCards.size > 0">
            <button 
              (click)="bulkRequestCards()"
              [disabled]="isUpdatingStatus"
              class="px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-x-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              <span>{{ isUpdatingStatus ? 'Procesando...' : 'Solicitar a DGT' }}</span>
            </button>
            
            <button 
              (click)="bulkMarkAsReceived()"
              [disabled]="isUpdatingStatus"
              class="px-4 py-2 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-x-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>{{ isUpdatingStatus ? 'Procesando...' : 'Marcar Recibidas' }}</span>
            </button>
            
            <button 
              (click)="bulkMarkAsDelivered()"
              [disabled]="isUpdatingStatus"
              class="px-4 py-2 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors duration-200 flex items-center gap-x-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span>{{ isUpdatingStatus ? 'Procesando...' : 'Marcar Entregadas' }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Loading state -->
      <div *ngIf="isLoadingCards" class="flex justify-center items-center py-12">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>

      <!-- Empty state -->
      <div *ngIf="!isLoadingCards && cards.length === 0" class="text-center py-12">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-16 h-16 mx-auto text-gray-300 mb-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
        </svg>
        <p class="text-gray-500 text-lg mb-2">No hay tarjetas creadas</p>
        <p class="text-gray-400 text-sm">Las tarjetas aparecerán aquí cuando se creen para los alumnos que se hayan sacado un carnet</p>
      </div>

      <!-- Grid de tarjetas -->
      <div *ngIf="!isLoadingCards && cards.length > 0" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div 
          *ngFor="let card of cards"
          (click)="toggleCardSelection(card.id)"
          [class]="selectedCards.has(card.id) 
            ? 'border-2 border-primary bg-blue-50' 
            : 'border border-gray-200 hover:border-primary hover:shadow-md'"
          class="rounded-lg p-4 cursor-pointer transition-all duration-200"
        >
          <!-- Checkbox y nombre -->
          <div class="flex items-start justify-between mb-3">
            <div class="flex items-center gap-x-3">
              <input 
                type="checkbox" 
                [checked]="selectedCards.has(card.id)"
                (click)="$event.stopPropagation()"
                (change)="toggleCardSelection(card.id)"
                class="w-5 h-5 text-primary border-gray-300 rounded focus:ring-primary"
              />
              <div>
                <h4 class="font-semibold text-dark">{{ card.user?.name || 'Sin nombre' }}</h4>
                <p class="text-xs text-gray-500" *ngIf="card.user?.nif">NIF: {{ card.user?.nif }}</p>
              </div>
            </div>
          </div>

          <!-- Estado actual -->
          <div 
            class="flex items-center justify-center text-xs rounded-lg p-2 mb-3"
            [style.background-color]="card.current_state?.color || '#gray'"
          >
            <span class="text-white font-medium">{{ card.current_state?.name || 'Sin estado' }}</span>
          </div>

          <!-- Información adicional -->
          <div class="space-y-1 text-xs text-gray-600">
            <div class="flex items-center gap-x-2" *ngIf="card.license?.name">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
              </svg>
              <span>Permiso: <strong>{{ card.license?.name }}</strong></span>
            </div>
            
            <div class="flex items-center gap-x-2" *ngIf="card.created_at">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              <span>Creada: {{ card.created_at | date:'dd/MM/yyyy' }}</span>
            </div>

            <div class="flex items-center gap-x-2" *ngIf="card.delivered_date">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span class="text-green-600">Entregada: {{ card.delivered_date | date:'dd/MM/yyyy' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal *ngIf="activeProofForm && proofForm"
  [title]="proofForm.formTitle"
  [fullscreen]="true"
  (close)="toggleActiveProofForm()">
  <app-generic-form (onFinished)="onFinishProofForm()" (onCancel)="toggleActiveProofForm()" [showCancel]="true" [genericForm]="proofForm" [selectedItem]="proof"></app-generic-form>
</app-modal>
